/*
  Product page per-size helper text (snippets/product-size-text.liquid).
  Listens to the theme's `variantChange` event on its own product section
  and swaps the text for the selected size.
*/
class SizeChartText extends HTMLElement {
  connectedCallback() {
    const data = this.querySelector('[data-size-texts]');
    this.output = this.querySelector('[data-size-text]');
    if (!data || !this.output) return;

    try {
      this.entries = JSON.parse(data.textContent);
    } catch (error) {
      return;
    }

    this.optionIndex = Number(this.dataset.optionIndex) || 0;
    this.container = this.closest('[data-section-type="product"]') || document;
    this.container.addEventListener('variantChange', this.onVariantChange);
  }

  disconnectedCallback() {
    this.container?.removeEventListener('variantChange', this.onVariantChange);
  }

  onVariantChange = (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    const size = String(variant.options[this.optionIndex] || '').trim().toUpperCase();
    const match = this.entries.find(([key]) => key === size);
    this.output.textContent = match ? match[1] : '';
  };
}

if (!customElements.get('size-chart-text')) {
  customElements.define('size-chart-text', SizeChartText);
}
